const subscribeEmailToNewsletter = `
    mutation SubscribeEmailToNewsletter($email: String!) {
        subscribeEmailToNewsletter(email: $email) {
            status
        }
    }
`;

export default {
    subscribeEmailToNewsletter,
};
